/* Maison Thaevia — Wishlist (localStorage) */
(function () {
  'use strict';

  var KEY = 'mt_wishlist';
  var _listeners = [];

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch (e) { return []; }
  }

  function _persist(items) {
    try { localStorage.setItem(KEY, JSON.stringify(items)); }
    catch (e) { /* storage full */ }
    _listeners.forEach(function (cb) { try { cb(items); } catch (e) {} });
  }

  function has(id) {
    id = String(id);
    return get().some(function (i) { return String(i.id) === id; });
  }

  function add(product) {
    if (has(product.id)) return;
    var items = get();
    items.unshift({
      id:     String(product.id),
      handle: product.handle || '',
      title:  product.title  || '',
      price:  product.price  || '',
      image:  product.image  || '',
      url:    product.url    || ('/products/' + (product.handle || '')),
      saved_at: Date.now()
    });
    _persist(items);
  }

  function remove(id) {
    id = String(id);
    _persist(get().filter(function (i) { return String(i.id) !== id; }));
  }

  function toggle(btn) {
    var id = btn.dataset.wishId;
    if (!id) return;
    if (has(id)) {
      remove(id);
      btn.classList.remove('is-saved');
      btn.setAttribute('aria-label', 'Save to wishlist');
    } else {
      add({
        id:     id,
        handle: btn.dataset.wishHandle || '',
        title:  btn.dataset.wishTitle  || '',
        price:  btn.dataset.wishPrice  || '',
        image:  btn.dataset.wishImage  || '',
        url:    btn.dataset.wishUrl    || ''
      });
      btn.classList.add('is-saved');
      btn.setAttribute('aria-label', 'Remove from wishlist');
      /* pulse animation */
      btn.classList.add('mt-wish-pulse');
      setTimeout(function () { btn.classList.remove('mt-wish-pulse'); }, 500);
    }
  }

  function onUpdate(cb) { _listeners.push(cb); }

  /* Sync all buttons on page to current saved state */
  function syncButtons() {
    document.querySelectorAll('[data-wish-id]').forEach(function (btn) {
      var saved = has(btn.dataset.wishId);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }

  _listeners.push(syncButtons);

  window.MTWishlist = { get: get, has: has, add: add, remove: remove, toggle: toggle, onUpdate: onUpdate };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }
})();
